import { useTheme } from "@emotion/react";

import {
  handleComponentsProp,
  useThemeProps,
  DevNotice,
  upperCamelCase,
  ensureArray,
} from "../../wsui/base";

import DefaultHits from "./DefaultHits.jsx";

function defaultComponentMapping({ searchPageType, contentType }) {
  return [
    contentType &&
      searchPageType &&
      `${upperCamelCase(contentType)}${upperCamelCase(searchPageType)}Hits`,
    contentType && `${upperCamelCase(contentType)}Hits`,
    searchPageType && `${upperCamelCase(searchPageType)}Hits`,
    "DefaultHits",
  ];
}

export default function HitsController(props) {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  props = useThemeProps({ props, name: "AlgoliaHitsController" });
  let {
    components = {},
    componentMapping = defaultComponentMapping,
    searchPageType,
    contentType,
    ...restProps
  } = props;

  const ownerState = {
    components,
    componentMapping,
    searchPageType,
    contentType,
    ...restProps,
  };

  components = handleComponentsProp(components, {
    DefaultHits,
    // SearchHits,
    // ArchiveHits,
  });
  let suggestedComponents = componentMapping(
    ownerState,
    defaultComponentMapping,
  );
  suggestedComponents = [
    ...ensureArray(suggestedComponents),
    ...ensureArray(defaultComponentMapping(ownerState)),
  ];
  suggestedComponents = suggestedComponents.map((Component) =>
    typeof Component === "string" ? components[Component] : Component,
  );
  let Component = suggestedComponents.find(Boolean);

  if (!Component) {
    return (
      <DevNotice>
        <details>
          <summary>{`Could not map HitsController to a component`}</summary>
          <pre>
            <code>{JSON.stringify(ownerState, null, 2)}</code>
          </pre>
        </details>
      </DevNotice>
    );
  }
  return <Component {...restProps} ownerState={ownerState} />;
}
